import './env';
import { auth } from './auth';

export { default as application } from './application';
export { default as elements } from './elements';
export { default as events } from './events';
export { default as info } from './info';
export { default as widget } from './widget';
export { default as inputs } from './inputs';
export { default as panels } from './panels';
export { default as modals } from './modals';
export { default as element, ElementSDKShape } from './element';
export { default as preferences } from './preferences';
export { default as externalPanels } from './externalPanels';
export { default as controllers } from './controllers';
export { default as bindings } from './bindings';
export { default as bindingsProviders } from './bindingsProviders';
export { BaseSDKShape } from './BaseSDKShape';
export { PlatformSDKShape } from './PlatformSDKShape';

import * as host from './host';

export const editor = {
  host: () => {
    const isWorker = typeof importScripts === 'function';

    if (isWorker) {
      return host.worker();
    }

    return host.frame();
  },
  auth,
};
